import { ASSETS } from "./assets";

// Liens externes & réseaux sociaux
export const INSTAGRAM_PROFILE_URL = "https://www.instagram.com/louismelchiordanse/";
export const INSTAGRAM_HANDLE = "@louismelchiordanse";
export const FACEBOOK_URL = "https://www.facebook.com/share/14a7zKs5b5L/?mibextid=wwXIfr";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CWvxlo82U0m1EAE/review";

export const videos = [
  {
    id: "presentation",
    title: "Présentation",
    subtitle: "Le style en quelques secondes",
    poster: ASSETS.louisHero,
    posterPosition: "object-[center_20%]",
    instagramUrl: "https://www.instagram.com/p/DX_Jl9NMXpH/",
  },
  {
    id: "demo-rock",
    title: "Démonstration rock",
    subtitle: "Énergie & complicité",
    poster: "/poster-rock.jpg",
    posterPosition: "object-center",
    instagramUrl: "https://www.instagram.com/reel/DX_P1uFgvvJ/",
  },
  {
    id: "demo-valse",
    title: "Démonstration valse",
    subtitle: "Élégance & fluidité",
    poster: "/poster-valse.jpg",
    posterPosition: "object-center",
    instagramUrl: "https://www.instagram.com/reel/DYEsZHxirKn/",
  },
];
